export default __webpack_public_path__ + "static/media/LOGO.16c6497e.png";